import { getFieldLabel } from "@/util/DataUtil";
export default {
  getHead: () => {
    return [{ name: getFieldLabel() }, { name: "계약명" }, { name: "안전·보건관리계획 이행 점검일" }, { name: "소속명" }, { name: "부서(업체)명" }, { name: "작성자" }];
  },
  getCol: (index, value, func) => {
    switch (index) {
    case 0:
      return func.getContent(value).stdInfo.field_name; // 사업장명
    case 1:
      return func.getContent(value).stdInfo.계약명; // 계약명
    case 2:
      return func.getContent(value).inputD_1; // 점검일
    case 3:
      return func.getContent(value).stdInfo.department; // 소속명
    case 4:
      return func.getContent(value).stdInfo.com_name; // 부서명
    case 5:
      return func.getContent(value).stdInfo.writer_name; // 작성자
    }
    return "";
  },
  getSearchKeyValue: (nav) => {
    if (nav.value.created_at) {
      nav.dateTarget = 'created_at'
      nav.dateBegin = 'nav.value.created_at.sDate'
      nav.dateEnd = 'nav.value.created_at.eDate'
    }
    return { searchType: nav.value.searchType, searchKeyword: nav.value.searchKeyword }
  },
  getSearchKeyword: (nav) => {
    switch (nav.value.searchType) {
    case getFieldLabel():
      return ["content$body.field_name*%[:default_skw]%"];
    case '계약명':
      return ["content$body.stdInfo.\"계약명\"*%[:default_skw]%"];
    case '안전·보건관리계획 이행 점검일':
      return ["content$body.inputD_1*%[:default_skw]%"];
    case "소속명":
      return ["content$body.stdInfo.department*%[:default_skw]%"];
    case "부서명":
      return ["content$body.stdInfo.com_name*%[:default_skw]%"];
    case "작성자":
      return ["content$body.stdInfo.writer_name*%[:default_skw]%"];
    }

    return [];
  },
};
